<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-11-17 10:06:45
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2023-11-24 14:38:15
 * @Description: 发放信息公式
 * @FilePath: \gfmis-card-ppt\src\views\issue\publicInfo.vue
-->
<template>
  <div class="pageRoot">
    <head-com class="head-com" :headObj="headObj"></head-com>
    <tree-table-com v-bind="tableConfig"></tree-table-com>
  </div>
</template>

<script>
import headCom from '@/components/headCom.vue';
import treeTableCom from '@/components/treeTableCom.vue'

export default {
  name: 'SubsidizeProject',
  data() {
    return {
      headObj: {
        cnTitleName: '发放信息公示',
        enTitleName: 'SUBSIDIES'
      },
      tableConfig: {
        isShowTree: true,
        tableColumn: [
          {
            field: 'date',
            title: '日期',
            width: 180
          },
          {
            field: 'name',
            title: '姓名',
            width: 100
          },
          {
            field: 'address',
            title: '地址',
            width: ''
          },
        ],
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }],
        treeData: [{
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
      }
    };
  },
  components: {
    headCom,
    treeTableCom
  },
  methods: {

  },
};
</script>

<style scoped lang="scss"></style>

